export default {"src":"/_next/static/media/defaultLogo.bc78596e.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};